import actionTypes from '../actions/actionsFactory/types';
import { bigNumberPlus, formatBigNumber } from '../utils/number';

export const INITIAL_STATE = {
  marginStatus: false, // margin tab
  marginAssetModeSwitching: false,
  marginBorrow_BUY: false, // todo state machine
  marginBorrow_SELL: false,
  marginAutoRepay_BUY: false,
  marginAutoRepay_SELL: false,
  marginStopLimitOrOCOTab: false, // false->stop-limit, true->oco
  marginAccount: {
    userAssets: [],
    marginLevel: '3.00',
    totalAssetOfBtc: '0',
    marginFreeAssets: {},
    interestRateMap: {},
    marginMaxBorrowable: {},
  },
  marginCoeff: {},
  marginAssets: [],
  marginSymbols: {},
  marginSymbolsFlat: [],
  isMarginPair: true,
};

const formatRisk = risk => {
  // eslint-disable-next-line prefer-const
  let [a, b = ''] = `${risk}`.split('.');
  b += '00';
  return `${a}.${b.substr(0, 2)}`;
};

const hanldeSymbols = (symbols = []) => symbols.reduce((pre, cur) => {
  pre[cur.base] ? pre[cur.base].push(cur) : pre[cur.base] = [cur];
  return pre;
}, {});

const handleMarginAccount = (maxBorrowable, {
  userAssets = [], marginLevel, interestRateMap = {}, marginBar = '', ...rest
}) => {
  const marginFreeAssets = {};
  const marginMaxBorrowable = { ...maxBorrowable };
  const newAssetArr = [];
  const debtMap = {};
  userAssets.forEach(({
    free, locked, asset, borrowed, interest, netAsset, netAssetOfBtc,
  }) => {
    marginFreeAssets[asset] = free;
    if (typeof marginMaxBorrowable[asset] === 'undefined') marginMaxBorrowable[asset] = 0;
    const debt = bigNumberPlus(borrowed, interest);
    debtMap[asset] = debt;
    newAssetArr.push({
      free,
      asset,
      locked,
      borrowed,
      interest,
      netAsset,
      netAssetOfBtc,
      totalDebt: debt,
      interestRate: interestRateMap[asset],
      totalAmount: bigNumberPlus(free, locked),
      _netAsset: formatBigNumber(netAsset, 4),
      _netAssetOfBTC: formatBigNumber(netAssetOfBtc, 4),
    });
  });
  return {
    ...rest,
    marginLevel: formatRisk(`${marginLevel}`),
    marginFreeAssets,
    marginMaxBorrowable,
    debtMap,
    interestRateMap,
    userAssets: newAssetArr,
    marginBar: marginBar.replace('_', ''),
  };
};

const handleMarginAccountMaxBorrowable = (marginAccount, borrows) => {
  const { marginMaxBorrowable } = marginAccount;
  const newMarginMaxBorrowable = { ...marginMaxBorrowable };
  Object.keys(borrows).forEach(k => { newMarginMaxBorrowable[k] = borrows[k]; });
  return { ...marginAccount, marginMaxBorrowable: newMarginMaxBorrowable };
};

export const reducer = (state, { type, data }) => {
  switch (type) {
    case actionTypes.SET_MARGIN_STATUS:
      return {
        ...state,
        marginStatus: data,
      };
    case actionTypes.SET_MARGIN_ASSET_MODE_START:
      return {
        ...state,
        marginAssetModeSwitching: true,
      };
    case actionTypes.SET_MARGIN_ASSET_MODE_BUY:
      return {
        ...state,
        marginAssetBuyMode: data,
      };
    case actionTypes.SET_MARGIN_ASSET_MODE_SELL:
      return {
        ...state,
        marginAssetSellMode: data,
      };
    case actionTypes.SET_MARGIN_ASSET_MODE_END:
      return {
        ...state,
        marginAssetModeSwitching: false,
      };
    case actionTypes.SET_MARGIN_BORROW:
      return {
        ...state,
        [`marginBorrow_${data.side}`]: data.status,
      };
    case actionTypes.SET_MARGIN_AUTO_REPAY:
      return {
        ...state,
        [`marginAutoRepay_${data.side}`]: data.status,
      };
    case actionTypes.SET_MARGIN_STOPLIMIT_OCO_TAB:
      return {
        ...state,
        marginStopLimitOrOCOTab: data,
      };
    case actionTypes.SET_MARGIN_ACCOUNT:
      return {
        ...state,
        marginAccount: handleMarginAccount(state.marginAccount.marginMaxBorrowable, data),
      };
    case actionTypes.SET_MARGIN_ACCOUNT_MAX_BORROWABLE:
      return {
        ...state,
        marginAccount: handleMarginAccountMaxBorrowable(state.marginAccount, data),
      };
    case actionTypes.SET_MARGIN_ASSETS:
      return {
        ...state,
        marginAssets: data,
      };
    case actionTypes.SET_MARGIN_COEFF:
      return {
        ...state,
        marginCoeff: data,
      };
    case actionTypes.SET_MARGIN_SYMBOLS:
      return {
        ...state,
        marginSymbols: hanldeSymbols(data),
        marginSymbolsFlat: data,
      };
    case actionTypes.SET_IS_MARGIN_PAIR:
      return {
        ...state,
        isMarginPair: data,
      };
    case actionTypes.SET_MARGIN_MODE_FALSE:
      return {
        ...state,
        marginAssetBuyMode: false,
        marginAssetSellMode: false,
      };
    case actionTypes.SET_MARGIN_MODE_TRUE:
      return {
        ...state,
        marginAssetBuyMode: true,
        marginAssetSellMode: true,
      };
    default:
      return state;
  }
};
